import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { map, take, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private afAuth: AngularFireAuth,
              private router: Router) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.afAuth.user.pipe(
      take(1), // Take 1 to complete the observable, otherwise it stays open
      map(user => !!user), // Map to boolean: true if user exists, false otherwise
      tap(loggedIn => {
        if (!loggedIn) {
          this.router.navigate(['']); // or your login route
        }
      })
    );
  }
}
